// extracted by mini-css-extract-plugin
export default {"CharacterInspector":"CharacterInspector_CharacterInspector__524Zo"};